
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/users/[id]/roadmaps",
      function () {
        return require("private-next-pages/users/[id]/roadmaps.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/users/[id]/roadmaps"])
      });
    }
  